{getHostname, partitionAndSort} = require('../../utils')

module.exports = (
  $scope,
  $q,
  $state,
  $stateParams,
  $sce,
  Api,
  settings,
  managedClient,
  workflowTemplate,
  WorkflowStepTemplate,
  workflowStepConfigs,
  workflowStepTemplates,
  $uibModal,
  User,
  countries
) ->

  autoSelectStep = () ->
    $scope.currentSelection = workflowStepTemplates.getFirst()

  selectRecentlyAddedStep = () ->
    $scope.currentSelection = workflowStepTemplates.getLast()

  $scope.user = User

  $scope.trustHtml = $sce.trustAsHtml

  $scope.getHostname = getHostname

  $scope.stepTypes = [
    {title: "Check for red flags?", filterTerm: "red_flag", expand: true},
    {title: "Does this company exist and who's affiliated?", filterTerm: "company_exist"},
    {title: "Screen for reputational risk?", filterTerm: "reputational_risk"},
    {title: "Identify legal history?", filterTerm: "legal_risk"},
    {title: "Check for political exposure?", filterTerm: "political_exposure"},
    {title: "Screen for supply chain risk?", filterTerm: "supply_chain"}
  ]

  $scope.steps = { other: {expand: true}, custom: {expand: true}}
  $scope.tab = 'guided'
  $scope.name_helper_text_error = ''

  $scope.addWorkflowStepTemplate = (step) ->
    if step?
      if $scope.checkCanAddSteps()
        $scope._addWorkflowStepTemplateToList(step)
    else
      alert "Please choose the type of template to add first"

  $scope._addWorkflowStepTemplateToList = (step) ->
    newWorkflowStepTemplate = new Api.WorkflowStepTemplate
      config: step.id

    WorkflowStepTemplate.decorate( newWorkflowStepTemplate )

    angular.extend(newWorkflowStepTemplate, step)
    newWorkflowStepTemplate.id = undefined

    if newWorkflowStepTemplate.supports_global or step.custom_step_url
      newWorkflowStepTemplate.search_scope = 'search_global'
    else if newWorkflowStepTemplate.supports_international
      newWorkflowStepTemplate.search_scope = 'search_international'
    else
      newWorkflowStepTemplate.search_scope = 'search_country'

    for wst in $scope.workflowStepTemplates
      wst.collapse = true

    $scope.workflowStepTemplates.push(newWorkflowStepTemplate)

  $scope.removeWorkflowStepTemplate = ( workflowStepTemplate ) ->
    workflowStepTemplate.deleted = true
    autoSelectStep()

  $scope.workflowStepUsed = (stepId, workflowStepTemplates) ->
    isUsed = (w for w in workflowStepTemplates when w.config is stepId and not w.deleted)
    return false if isUsed.length is 0
    true

  $scope.deleteWorkflow = () ->
    r = confirm("Are you sure you want to delete this workflow?")
    if r
      wtp = $scope.workflowTemplate.$delete()
      wtp.then () ->
        $state.transitionTo('preferences-workflow-list', {}, {
          reload: 'preferences-workflow-list'
        })
    return

  $scope._saveOrUpdate = (resource) ->
    resource[if resource.id then '$update' else '$save']()

  $scope._saveOrUpdateAll = (resources) ->
    if resources then $q.all(resources.map($scope._saveOrUpdate)) else $q.when()

  $scope._populateStepModifier = (stepModifier, wst) ->
    stepModifier.step = stepModifier.step || wst.config

  $scope._populateStepModifierForStep = ( wst ) ->
    stepModifier = wst.stepmodifier
    $scope._populateStepModifier( stepModifier, wst )

  $scope._populateStepModifiers = (workflowSteps) ->
    $q.all(workflowSteps.map($scope._populateStepModifierForStep))

  $scope._saveWorkflowTemplate = (workflowTemplate) ->
    $scope._saveOrUpdate(workflowTemplate)

  $scope._saveWorkflowStepTemplates = (workflowStepTemplates) ->
    $scope._saveOrUpdateAll(workflowStepTemplates)

  $scope._populateWorkflowStepTemplates = (workflowStepTemplates, workflowTemplate) ->
    for wst, index in workflowStepTemplates
      wst.workflow_template = workflowTemplate.id
      wst.order = index

  $scope._deleteWorkflowStepTemplates = (workflowStepTemplates, isNew) ->
    if isNew then $q.when() else $q.all(workflowStepTemplates.map((wst) ->
      wst.$delete()
    ))

  $scope._getDeletedWorkflowStepTemplates = (workflowStepTemplates) ->
    (wst for wst in workflowStepTemplates when wst.deleted)

  $scope._getNonDeletedWorkflowStepTemplates = (workflowStepTemplates) ->
    (wst for wst in workflowStepTemplates when not wst.deleted)

  $scope.saveWorkflow = (workflowForm) ->
    workflowForm.$submitted = true
    if !workflowForm.$valid
      return

    $scope.saving = true
    $scope.name_helper_text_error = ''

    nonDeletedWorkflowStepTemplates = $scope._getNonDeletedWorkflowStepTemplates($scope.workflowStepTemplates)
    $scope._populateStepModifiers(nonDeletedWorkflowStepTemplates)

    saveWorkflowTemplate = $scope._saveWorkflowTemplate($scope.workflowTemplate).then () ->
      $scope._populateWorkflowStepTemplates(nonDeletedWorkflowStepTemplates, $scope.workflowTemplate)

    saveWorkflowStepTemplates = saveWorkflowTemplate.then () ->
      $scope._saveWorkflowStepTemplates(nonDeletedWorkflowStepTemplates)

    isNew = !$scope.workflowTemplate.id
    deletedWorkflowStepTemplates = $scope._getDeletedWorkflowStepTemplates($scope.workflowStepTemplates)
    deleteWorkflowStepTemplates = $scope._deleteWorkflowStepTemplates(deletedWorkflowStepTemplates, isNew)

    allSaved = $q.all([saveWorkflowStepTemplates, deleteWorkflowStepTemplates])
    allSaved.then(() ->
      $scope.saving = false
      # redirect to somewhere more relevant
      $state.go('preferences-workflow-list')
    ).catch((error) ->
      $scope.saving = false

      if error.data?.name?
        $scope.name_helper_text_error = error.data.name[0]

      throw error
    )

  $scope.checkCanAddSteps = () ->
    return workflowStepTemplates.getCount() < $scope.maxSteps

  $scope.getDescription = (id) ->
    (c for c in workflowStepConfigs when c.id is id)[0]?.description

  $scope.hasCustomSteps = (steps) ->
    (s for s in steps or [] when s.custom_step_url).length > 0

  $scope.hasArachnysSteps = (steps) ->
    (s for s in steps or [] when !s.custom_step_url).length > 0

  $scope.isCustomStepUrl = (item) ->
    item.custom_step_url == null

  $scope.addCustomStep = () ->
    customStepModal = $uibModal.open
      template: require('./CustomStepModal/edit-custom-steps.html')
      controller: 'CustomStepModalController'
      resolve:
        customStep: () ->
          return

    customStepModal.result.then () ->
      Api.WorkflowStepConfig.query(archived: false).$promise.then (workflowStepConfigs) ->
        $scope.workflowStepConfigs = workflowStepConfigs

  $scope.editCustomStep = (step) ->
    customStepModal = $uibModal.open
      template: require('./CustomStepModal/edit-custom-steps.html')
      controller: 'CustomStepModalController'
      resolve:
        customStep: () ->
          step

    customStepModal.result.then () ->
      Api.WorkflowStepConfig.query(archived: false).$promise.then (workflowStepConfigs) ->
        $scope.workflowStepConfigs = workflowStepConfigs

  $scope.select = ( step ) ->
    $scope.currentSelection = step

  $scope.getSelection = () ->
    $scope.currentSelection

  $scope.getConfig = () ->
    for config in workflowStepConfigs
      if config.id == $scope.currentSelection.config
        return config

  $scope.isSelectionAStep = () ->
    $scope.getSelection() in workflowStepTemplates.getNonDeleted()

  $scope.isSelectionAnAvailableStep = () ->
    $scope.getSelection() in workflowStepConfigs

  $scope.addAvailableStep = ( availableStep ) ->
    $scope.addWorkflowStepTemplate( availableStep )
    selectRecentlyAddedStep()

  # ==================
  # ===== Scope ======
  # ==================

  $scope.workflowStepConfigs = workflowStepConfigs
  workflowStepTemplates.sort()
  $scope.workflowStepTemplates = workflowStepTemplates

  if not $stateParams.workflowId
    $scope.isNew = true

  $scope.workflowTemplate = workflowTemplate
  $scope.workflowTemplate.manual_check_warnings ?= true

  $scope.managedClient = managedClient

  $scope.saving = false
  $scope.maxSteps = settings.MAX_STEPS_IN_WORKFLOW_TEMPLATE

  $scope.stepFilter = ''

  $scope.countries = countries

  autoSelectStep()
